import { ContractService } from './contract.service';

export const services = [ContractService];

export * from './contract.service';
